import { render, staticRenderFns } from "./CostReports.vue?vue&type=template&id=06fe8f43&"
import script from "./CostReports.vue?vue&type=script&lang=js&"
export * from "./CostReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports